module.exports = __webpack_public_path__ + "img/delay.4df1eaa3.svg";